import React from 'react';
import EditablePanel, { EditablePanelProps } from '../../../../components/EditablePanel';
import FormWidget from '../../../../form/FormWidget';
import { FORM_WIDGET_COMPONENTS } from '../../../../form/formConstants';
import { useI18n } from '../../../../i18n/I18n';
import { APPROVAL_EDITABLE_PANEL_HEADER_SX } from '../../../constants';
import { useCreateApprovalContext } from '../../hooks/useCreateApprovalContext';
import CreateApprovalFormEditablePanelHeader from '../CreateApprovalFormEditablePanelHeader';

export type ApprovalStrategyFormFieldProps = Pick<EditablePanelProps, 'isCollapsable' | 'defaultCollapsed'>;

export default function ApprovalSummaryFormField({ isCollapsable, defaultCollapsed }: ApprovalStrategyFormFieldProps) {
    const { isSavingApprovalInput } = useCreateApprovalContext();

    const approvalSummaryPlaceholder = useI18n('approval.summary.placeholder');

    return (
        <EditablePanel
            Header={<CreateApprovalFormEditablePanelHeader titleToken={'approval.summary.header'} />}
            isCollapsable={isCollapsable}
            defaultCollapsed={defaultCollapsed}
            headerSx={APPROVAL_EDITABLE_PANEL_HEADER_SX}
        >
            <FormWidget
                component={FORM_WIDGET_COMPONENTS.richText}
                name="summary"
                contentPlaceholder={approvalSummaryPlaceholder}
                readOnly={isSavingApprovalInput}
            />
        </EditablePanel>
    );
}
